import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface PlumbingFixturesProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const PlumbingFixtures: React.FC<PlumbingFixturesProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [plumbingFixtures, set_plumbingFixtures] = useBudgetConstructionField<number>(
        propertyGuid,
        (b) => b.values?.['Interior Finishes']?.['Plumbing Fixtures'] ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Interior Finishes': { ...b.values?.['Interior Finishes'], 'Plumbing Fixtures': v } } })
    );
    const label = 'Plumbing Fixtures';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(plumbingFixtures)}
                />
            ) : (
                <MoneyBox
                    id={'plumbingFixtures'}
                    allowNegative={false}
                    value={plumbingFixtures}
                    onChange={(value) => set_plumbingFixtures(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
